'use client';

import CommonBreadcrumbs from '@/components/CommonBreadcrumbs';
import { motion } from 'framer-motion';
import Image from 'next/image';
import { ContactUsForm } from './contact-us-form';
import ContactUsInfo from './contact-us-info';
import { Info2 } from './info-2';

const paths = [
  {
    text: 'Home',
    path: '/',
  },
  {
    text: 'contact us',
    path: '/contact-us',
    current: true,
  },
];

// 注意：hidden 变体不再设 opacity:0，仅保留位移动画。
// 否则服务端渲染出的首屏 HTML 会带 style="opacity:0"，
// 在 JS 执行前（含搜索引擎抓取快照）内容视觉为空，影响收录。
const fadeIn = {
  hidden: {
    y: 20,
  },
  visible: {
    opacity: 1,
    y: 0,
  },
};

const staggerChildren = {
  hidden: {},
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const ContactUsPage = () => {
  return (
    <motion.div
      initial='hidden'
      animate='visible'
      variants={staggerChildren}
    >
      <Image
        src='/images/contact-us/banner-m.webp'
        width={375}
        height={200}
        className='block h-auto w-full lg_hidden'
        alt=''
        unoptimized
        priority
      />
      <Image
        src='/images/contact-us/banner.webp'
        width={1920}
        height={370}
        className='hidden h-auto w-full lg_block'
        alt=''
        unoptimized
        priority
      />

      <div className='block bg-[#EFEFEF] p-[20px] lg_hidden'>
        <p className='font-poppins text-[30px] font-[700] uppercase text-title'>WE ARE HERE TO HELP</p>
        <p className='mt-[10px] font-sans text-title'>
          At Kingsyard, your questions and feedback matter. Reach out to us—we're always happy to assist you.
        </p>
      </div>

      <motion.div
        variants={fadeIn}
        transition={{
          duration: 0.5,
          delay: 0.2,
        }}
        className='mx-auto mt-10 max-w-[1440px] px-4'
      >
        <CommonBreadcrumbs paths={paths} />
      </motion.div>

      <motion.h1
        variants={{
          hidden: {
            y: -20,
          },
          visible: {
            opacity: 1,
            y: 0,
          },
        }}
        transition={{
          duration: 0.6,
          delay: 0.4,
        }}
        className='mt-10 text-center font-poppins text-[24px] font-[600] uppercase text-primary lg_text-[30px]'
      >
        Contact Us
      </motion.h1>

      <motion.div
        className='mx-auto mt-12 flex w-full max-w-[1440px] flex-col justify-between gap-0 px-4 pb-10 lg_flex-row lg_gap-20 lg_pb-20'
        variants={staggerChildren}
        transition={{
          delayChildren: 0.6,
        }}
      >
        <motion.div
          variants={{
            hidden: {
              x: -30,
            },
            visible: {
              opacity: 1,
              x: 0,
            },
          }}
          transition={{
            duration: 0.7,
          }}
          className='w-full lg_w-1/2'
        >
          <ContactUsInfo />
          <Info2 className='hidden lg_block' />
        </motion.div>

        <motion.div
          variants={{
            hidden: {
              x: 30,
            },
            visible: {
              opacity: 1,
              x: 0,
            },
          }}
          transition={{
            duration: 0.7,
            delay: 0.2,
          }}
          className='w-full lg_w-1/2'
        >
          <ContactUsForm />
        </motion.div>
      </motion.div>

      <Info2 className='block px-4 pb-20 lg_hidden' />
    </motion.div>
  );
};

export default ContactUsPage;
